export interface Trend {
  direction: 'up' | 'down';
  percentChange: number;
}

export function computeTrend(
  value: number | string,
  prevValue: number | string | undefined
): Trend | null {
  if (typeof value === 'number' && typeof prevValue === 'number') {
    if (prevValue === 0) {
      return {
        direction: value > 0 ? 'up' : 'down',
        percentChange: value > 0 ? 100 : 0,
      };
    } else {
      const percentChange = ((value - prevValue) / prevValue) * 100;
      return {
        direction: value > prevValue ? 'up' : 'down',
        percentChange: Math.abs(parseFloat(percentChange.toFixed(2))),
      };
    }
  }
  return null;
}
